module.exports = __webpack_public_path__ + "4883972e9c1a3b40f0c824720a6c9c81.glb";